// src/adminComponent/viewEmployees/AvatarEditorDialog.js
import React, { useState, useRef } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Slider } from '@mui/material';

const AvatarEditorDialog = ({ open, onClose, onSave, image }) => {
  const editorRef = useRef(null);
  const [scale, setScale] = useState(1);

  const handleScaleChange = (event, newValue) => {
    setScale(newValue);
  };

  const handleSave = () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas().toDataURL();
      onSave(canvas);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Avatar</DialogTitle>
      <DialogContent>
        <AvatarEditor
          ref={editorRef}
          image={image}
          width={250}
          height={250}
          border={50}
          borderRadius={125}
          scale={scale}
          rotate={0}
        />
        <Slider
          value={scale}
          min={1}
          max={2}
          step={0.01}
          onChange={handleScaleChange}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: 'red' }}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" sx={{ backgroundColor: '#39B54A', '&:hover': { backgroundColor: '#2c8f39' } }}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AvatarEditorDialog;
